module.exports = __webpack_public_path__ + "58e13eec052e68c24e586f08b94505f2.svg";